import React, { useRef } from 'react';
import './gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import twosingle from "../../assets/two-single.png";
import onedouble from "../../assets/one-double.png";
import twoone from "../../assets/two-one.png";
import twodouble from "../../assets/two-double.png";
import fivesingle from "../../assets/five-single.png";
import presidential from "../../assets/presidential.png";
import pool from "../../assets/pool.png";
import gym from "../../assets/gym.png";
import restaurant from "../../assets/restaurant.png";
import conference from "../../assets/conference.png";
import room1 from "../../assets/room1.jfif";
import room2 from "../../assets/room2.jfif";
import room3 from "../../assets/room3.jfif";
import outside from "../../assets/outsidehotel.png";
import inside from "../../assets/hotelinside.png";
import $ from "jquery";

const Gallery = () => {

    const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };

  $(document).ready(function(){
    $(".divgray").hide();

    $("#gall1").click(function(){
        $("#gallery1").fadeIn();
    });

    $("#gallery1").click(function(){
        $(this).fadeOut();
    });

    $("#gall2").click(function(){
        $("#gallery2").fadeIn();
    });

    $("#gallery2").click(function(){
        $(this).fadeOut();
    });

    $("#gall3").click(function(){
        $("#gallery3").fadeIn();
    });

    $("#gallery3").click(function(){
        $(this).fadeOut();
    });

    $("#gall4").click(function(){
        $("#gallery4").fadeIn();
    });

    $("#gallery4").click(function(){
        $(this).fadeOut();
    });

    $("#gall5").click(function(){
        $("#gallery5").fadeIn();
    });

    $("#gallery5").click(function(){
        $(this).fadeOut();
    });

    $("#gall6").click(function(){
        $("#gallery6").fadeIn();
    });

    $("#gallery6").click(function(){
        $(this).fadeOut();
    });

    $("#gall7").click(function(){
        $("#gallery7").fadeIn();
    });

    $("#gallery7").click(function(){
        $(this).fadeOut();
    });

    $("#gall8").click(function(){
        $("#gallery8").fadeIn();
    });

    $("#gallery8").click(function(){
        $(this).fadeOut();
    });

    $("#gall9").click(function(){
        $("#gallery9").fadeIn();
    });

    $("#gallery9").click(function(){
        $(this).fadeOut();
    });

    $("#gall10").click(function(){
        $("#gallery10").fadeIn();
    });

    $("#gallery10").click(function(){
        $(this).fadeOut();
    });

    $("#gall11").click(function(){
        $("#gallery11").fadeIn();
    });

    $("#gallery11").click(function(){
        $(this).fadeOut();
    });

    $("#gall12").click(function(){
        $("#gallery12").fadeIn();
    });

    $("#gallery12").click(function(){
        $(this).fadeOut();
    });

    $("#gall13").click(function(){
        $("#gallery13").fadeIn();
    });

    $("#gallery13").click(function(){
        $(this).fadeOut();
    });

    $("#gall14").click(function(){
        $("#gallery14").fadeIn();
    });

    $("#gallery14").click(function(){
        $(this).fadeOut();
    });

    $("#gall15").click(function(){
        $("#gallery15").fadeIn();
    });

    $("#gallery15").click(function(){
        $(this).fadeOut();
    });
  });

    return (
        <div>
            <div id='gallerybanner' className="pagebanner">
                <h1>Gallery</h1>
            </div>

            <h1 id='expgallery'>Tour our hotel gallery</h1>

            <Swiper
                id='swipergallery'
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                delay: 3500,
                disableOnInteraction: false,
                }}
                pagination={{
                clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                onAutoplayTimeLeft={onAutoplayTimeLeft}
                className="mySwiper"
                >
                <SwiperSlide className='galleryslide'><img src={onedouble} alt="" /><img src={twodouble} alt="" /><img src={presidential} alt="" /></SwiperSlide>
                <SwiperSlide className='galleryslide'><img src={twosingle} alt="" /><img src={fivesingle} alt="" /><img src={twoone} alt="" /></SwiperSlide>
                <SwiperSlide className='galleryslide'><img src={restaurant} alt="" /><img src={fivesingle} alt="" /><img src={twoone} alt="" /></SwiperSlide>
                <SwiperSlide className='galleryslide'><img src={pool} alt="" /><img src={gym} alt="" /><img src={conference} alt="" /></SwiperSlide>
                <SwiperSlide className='galleryslide'><img src={room1} alt="" /><img src={room2} alt="" /><img src={room3} alt="" /></SwiperSlide>
                <div className="autoplay-progress" slot="container-end">
                <svg viewBox="0 0 48 48" ref={progressCircle}>
                    <circle cx="24" cy="24" r="20"></circle>
                </svg>
                <span ref={progressContent}></span>
                </div>
            </Swiper>

            <h1 className='galleryheading'>All gallery photos</h1>

            <div id="photos">
                <img src={room1} alt="" id='gall1' /><img src={room2} alt="" id='gall2'/><img src={room3} alt="" id='gall3'/>
                <img src={pool} alt="" id='gall4'/><img src={gym} alt="" id='gall5'/><img src={conference} alt=""id='gall6' />
                <img src={onedouble} alt="" id='gall7'/><img src={twodouble} alt="" id='gall8'/><img src={presidential} alt="" id='gall9'/>
                <img src={twosingle} alt="" id='gall10'/><img src={fivesingle} alt="" id='gall11'/><img src={twoone} alt="" id='gall12'/>
                <img src={restaurant} alt="" id='gall13'/><img src={outside} alt="" id='gall14'/><img src={inside} alt="" id='gall15'/>
            </div>

            <div className='divgray' id='gallery1'>
                <img src={room1} alt="" />
            </div>

            <div className='divgray' id='gallery2'>
                <img src={room2} alt="" />
            </div>

            <div className='divgray' id='gallery3'>
                <img src={room3} alt="" />
            </div>

            <div className='divgray' id='gallery4'>
                <img src={pool} alt="" />
            </div>

            <div className='divgray' id='gallery5'>
                <img src={gym} alt="" />
            </div>

            <div className='divgray' id='gallery6'>
                <img src={conference} alt="" />
            </div>

            <div className='divgray' id='gallery7'>
                <img src={onedouble} alt="" />
            </div>

            <div className='divgray' id='gallery8'>
                <img src={twodouble} alt="" />
            </div>

            <div className='divgray' id='gallery9'>
                <img src={presidential} alt="" />
            </div>

            <div className='divgray' id='gallery10'>
                <img src={twosingle} alt="" />
            </div>

            <div className='divgray' id='gallery11'>
                <img src={fivesingle} alt="" />
            </div>

            <div className='divgray' id='gallery12'>
                <img src={twoone} alt="" />
            </div>

            <div className='divgray' id='gallery13'>
                <img src={restaurant} alt="" />
            </div>

            <div className='divgray' id='gallery14'>
                <img src={outside} alt="" />
            </div>

            <div className='divgray' id='gallery15'>
                <img src={inside} alt="" />
            </div>
           
        </div>
    );
}
 
export default Gallery;